import { distinctUntilChanged, map, type Observable } from 'rxjs';
import { userOperations } from '@ardoq/core';
import { isTruthy } from '@ardoq/common-helpers';
import { currentUser$ } from './currentUser/currentUser$';

/**
 * Whether the current user's role lets them write data — the same check the API
 * makes for `user.writeAccess`.
 *
 * `currentUser$` rather than `loadedCurrentUser$`: the latter never emits in a
 * public presentation, which would stall consumers combining this. A user that
 * has not loaded reads as no write access, so callers gating on this fail closed.
 */
export const hasWriteAccess$: Observable<boolean> = currentUser$.pipe(
  map(user => isTruthy(user) && userOperations.hasWriterRolePlus(user)),
  distinctUntilChanged()
);
